import { useMemo } from "react"
import { useURLSearchParams } from "~/ui-rtk/hooks/url"
import { URL_PARAM_TO_WIDGET_MAP } from "../constants"
import { URL_WIDGET_PARAM_KEY } from "~/ui-rtk/constants/url-params"
import {
  type TBrandMediaOptimizationTableId,
  type TBrandMediaOptimizationTable,
} from "~/ui-rtk/pages/BrandMedia/PaidMediaWeights/connect"
import TabsGroup from "~/ui-rtk/components/ui/controls/TabsGroup/TabsGroup"

interface TabContainerProps {
  visibleWidgets: Record<
    TBrandMediaOptimizationTableId,
    TBrandMediaOptimizationTable
  >
  onTabChange: (widgetId: string) => void
}

export function TabContainer({
  visibleWidgets,
  onTabChange,
}: TabContainerProps) {
  const { params } = useURLSearchParams()

  const defaultVisibleChart = useMemo(
    () =>
      visibleWidgets[
        Object.keys(
          visibleWidgets,
        )[0] as unknown as TBrandMediaOptimizationTableId
      ],
    [visibleWidgets],
  )

  const widgetURLSearchParam =
    params[URL_WIDGET_PARAM_KEY] ?? defaultVisibleChart?.id

  const activeWidget = useMemo(
    () =>
      widgetURLSearchParam && URL_PARAM_TO_WIDGET_MAP[widgetURLSearchParam]
        ? visibleWidgets[
            widgetURLSearchParam.toUpperCase() as TBrandMediaOptimizationTableId
          ]
        : defaultVisibleChart,
    [widgetURLSearchParam, visibleWidgets, defaultVisibleChart],
  )

  const handleSetWidget = (widgetId: string) => {
    onTabChange(widgetId)
  }

  return (
    <div className="my-system-xl">
      <TabsGroup
        options={Object.values(visibleWidgets).map(tab => ({
          label: tab.label,
          id: tab.id,
        }))}
        onChange={value =>
          handleSetWidget(Object.values(visibleWidgets)[value].id)
        }
        index={Object.values(visibleWidgets).findIndex(
          tab => tab.id === activeWidget?.id,
        )}
      >
        {tab => (
          <div className="flex items-center gap-system-xs">
            <span>{tab.label}</span>
          </div>
        )}
      </TabsGroup>
    </div>
  )
}

export default TabContainer
